export const admissionTypeDescriptions = {
    CIV: "Civis",
    ΑΓΝ: "Άγνωστος κωδικός",
    ΑΔΣ: "Απόφαση δ.σ. του τμήματος",
    ΑΘΑ: "Ως αθλητής",
    ΑΘΓ: "Ως αθλήτρια",
    ΑΘΛ: "Αθλητές",
    ΑΚΑ: "Αλλογενείς αλλοδαποί κοινοτ. υπότροφοι",
    ΑΛΑ: "Ως αλλοδαπός",
    ΑΛΓ: "Ως αλλοδαπή",
    ΑΛΕ: "Απόφοιτοι λυκείων εξωτερικού",
    ΑΛΚ: "Αλλαγή κατεύθυνσης",
    ΑΛΣ: "Αλλοδαπός(-η) σ.α.ν.",
    ΑΜΕ: "Αναδρ.εγкр. μετεγγραφής απο γ.σ.",
    ΑΥΑ: "Ως αλλοδαπός υπότροφος",
    ΑΥΓ: "Ως αλλοδαπή υπότροφος",
    ΔΘΑ: "Διεθνείς ανταλλαγές/erasmus",
    ΔΘΣ: "Διεθνείς συνεργασίες",
    ΔΙΚ: "Κατάταξη δικατσα - δοαταπ",
    ΔΙΚ2: "Κατάταξη δικατσα",
    ΕΑΦ: "Επανεγγραφή μετα απο απολυτήριο",
    ΕΓΕ: "Ένταξη στο γ εξάμηνο (αποφ.συγκλήτου)",
    ΕΓΣ: "Επανεγγραφή (αποφ. γεν. συνέλευσης)",
    ΕΕΠ: "Ένταξη απο ειδικά προγράμματα",
    ΕΙΔ: "Ειδικές ανάγκες",
    ΕΙΠ: "Ειδικές περιπτώσεις",
    ΕΚΛ: "Ανώτερες εκκλησιαστικές σχολές",
    ΕΞΑ: "Ως έλληνας εξωτερικού",
    ΕΞΓ: "Ως ελληνίδα εξωτερικού",
    ΕΞΟ: "Εξομοίωση πτυχίου παιδαγωγικών ακαδημιών",
    ΕΠΑ: "Καθ' υπερ/φ.152/β6/198/00",
    ΕΠΒ: "Καθ' υπερβ.φ243/β6/755/00",
    ΕΠΓ: "Καθ΄ υπερβ.φ151/20049/β6/272/07",
    ΕΠΔ: "Καθ΄ υπερβ.φ151/17104/β6/259/06",
    ΕΠΕ: "Υπουργική απόφαση φ.253/β6/755/30-5-2000",
    ΕΠΖ: "Υπουργική απόφαση εσωτ.φ.25225/β6/200/6-4-00",
    ΕΠΗ: "Καθ΄ υπερβ.φ151/20049/β6 φεκ 156-α/04.09.09",
    ΕΠΘ: "Υπουργική απόφαση φ.152/β6/198/2000ν.3794/4.9.2009",
    ΕΠΞ: "Επανένταξη σε νέο πρόγραμμα (εξάμηνα)",
    ΕΠΥ: "Καθ΄ υπέρβαση 5%",
    ΕΠΦ: "Καθ' υπέρβαση λόγω φυσικών καταστροφών",
    ΕΣΚ: "Εσωτερική κινητικότητα",
    ΚΑΕ: "Κατάταξη πτυχιούχου αει",
    ΚΑΤ: "Κατατακτήριες",
    ΚΒΑ: "Κατάταξη με batchelor",
    ΚΔΕ: "Κατάταξη διετούς",
    ΚΔΙ: "Κατάταξη δι.κα.τσα.",
    ΚΜΑ: "Κατάταξη με master",
    ΚΞΠ: "Κάτοχος τίτλων σπουδών ξένων πανεπιστημίων",
    ΚΟΑ: "Κοινοτικοί αλλοδαποί",
    ΚΠΤ: "Κατάταξη πτυχιούχου αει-τει",
    ΚΤΔ: "Κατάταξη πτυχιούχου δραματικής σχολής",
    ΚΤΕ: "Κατάταξη πτυχιούχου τει",
    ΚΥΑ: "Ως κύπριος",
    ΚΥΓ: "Ως κύπρια",
    ΚΥΠ: "Κύπριοι",
    ΚΩΦ: "Κωφαλάλοι",
    ΛΥΓ: "Λόγοι υγείας - ανευ εξετάσεων",
    ΜΑΒ: "Διάκριση σε επιστημονικές ολυμπιάδες",
    ΜΑΓ: "Μετεγγραφή λόγω απώλειας γονέα",
    ΜΑΘ: "Μαθηματική ολυμπιάδα",
    ΜΑΝ: "Μεσογειακή αναιμία",
    ΜΕΑ: "Μετεγγραφή αθλητή",
    ΜΕΞ: "Μετεγγραφή εξωτερικού",
    ΜΕΣ: "Μετεγγραφή εσωτερικού",
    ΜΕΤ: "Απο μετεγγραφή",
    ΜΘΓ: "Μετεγγραφή λόγω ασθένειας γονέα",
    ΜΘΡ: "Μουσουλμάνοι θράκης",
    ΜΙΣ: "Μετεγγραφή ισοβαθμισάντων",
    ΜΚΥ: "Μετεγγραφή απο κύπρο",
    ΜΛΑ: "Μετεγγραφή λόγω φοιτούντος αδελφού",
    ΜΛΓ: "Μετεγγραφή λόγω φοιτούντος γονέα",
    ΜΛΘ: "Μετεγγραφή λόγω ασθένειας",
    ΜΛΜ: "Μετεγγραφή ως μητέρα ανηλίκων",
    ΜΛΣ: "Μετεγγραφή λόγω φοιτούντος συζύγου",
    ΜΟΡ: "Μετεγγραφή βασει ν3282/04 (ως ορφανό τέκνο)",
    ΜΤΘ: "Μεταφορά θέσης",
    ΜΤΛ: "Μετεγγραφή ως τέκνο πολυμελούς οικογένειας",
    ΜΤΠ: "Μετεγγραφή ως τέκνο πολυτέκνων",
    Ν2640: "Ν.2640/98",
    Ν3763: "Ν.3763/2009",
    Ν3794: "Ν.3794/09",
    ΟΜΟ: "Ως ομογενής",
    ΟΜΥ: "Ως ομογενής υπότροφος",
    ΠΑΔΕ: "Πανελλήνιες εξετάσεις (απόφαση διοικητικού εφετείου αθηνών)",
    ΠΑΚ: "Παιδαγωγικές ακαδημίες",
    ΠΑΝ: "Πανελλήνιες εξετάσεις",
    ΠΑΣ: "Πανελλήνιες εξετάσεις (απόφαση συγκλήτου)",
    ΠΚΚ: "Πανελλήνιες ειδ.περιπτ.-κοινων. κριτήρια",
    ΠΠΟ: "Πανελλήνιες ειδικές περιπτώσεις-πολύτεκνοι",
    ΠΣΕ: "Εγγραφή ως πρώην π.σ.ε.",
    ΠΤΡ: "Πανελλήνιες ειδικές περιπτώσεις-τρίτεκνοι",
    ΣΑΝ: "Απο σχολή αξιωματικών νοσηλευτικής",
    ΣΕΙ: "Σεισμοπλήκτος",
    ΣΤΡ: "Στρατιωτικές σχολές",
    ΤΕΑ: "Τέκνα αναπήρων",
    ΤΕΞ: "Τέκνα ελλήνων εξωτερικού",
    ΤΕΠ: "Τέκνα πολυτέκνων",
    ΤΠΛ: "Τέκνα πολυμελών οικογενειών",
    ΤΥΞ: "Τέκνα ελλήνων υπαλλήλων του εξωτερικού",
    ΤΥΦ: "Τυφλοί",
    ΥΑΑ: "Υπότροφος ακαδημίας αθηνών",
    ΥΙΚ: "Ως υπότροφος ι.κ.υ.",
    ΥΥΕ: "Ως υπότροφος υπ.εξ.",
    ΥΥΠ: "Ως υπότροφος υ.π.ε.π.θ",
    ΦΕΠ: "Φοιτητές ειδικών προγραμμάτων",
    ΦΠΨ: "Ένταξη απο φ.π.ψ.",
    ΦΣΓ: "Εκ του καταργηθέντος φυσιογνωστικού"
};

export const admissionTypeGroups = {
    // Πανελλήνιες
    ΠΑΝ: "Πανελλήνιες",
    ΠΑΣ: "Πανελλήνιες",
    ΠΑΔΕ: "Πανελλήνιες",
    ΠΠΟ: "Πανελλήνιες",
    ΠΚΚ: "Πανελλήνιες",
    ΠΤΡ: "Πανελλήνιες",
    ΠΣΕ: "Πανελλήνιες",

    // Μετεγγραφές
    ΜΕΣ: "Μετεγγραφές",
    ΜΕΤ: "Μετεγγραφές",
    ΜΕΞ: "Μετεγγραφές",
    ΜΛΘ: "Μετεγγραφές",
    ΜΛΑ: "Μετεγγραφές",
    ΜΛΜ: "Μετεγγραφές",
    ΜΛΓ: "Μετεγγραφές",
    ΜΛΣ: "Μετεγγραφές",
    ΜΘΓ: "Μετεγγραφές",
    ΜΘΡ: "Μετεγγραφές",
    ΜΚΥ: "Μετεγγραφές",
    ΜΟΡ: "Μετεγγραφές",
    ΜΙΣ: "Μετεγγραφές",
    ΜΤΘ: "Μετεγγραφές",
    ΜΤΛ: "Μετεγγραφές",
    ΜΤΠ: "Μετεγγραφές",

    // All others not explicitly listed will fall under "Άλλο" (handled in logic)
};

export const statusDescriptions = {
    ΑΝ: "Αναστολή φοίτησης",
    ΑΝΕ: "Ανενεργός",
    ΔΙ: "Διαγραφή",
    ΕΝ: "Ενεργός (είναι μέχρι και ν έτος)",
    ΕΠ: "Επί πτυχίω (ενεργός σε έτος μετά τα ν)",
    ΠΤ: "Πτυχιούχος",
};
